import { render, staticRenderFns } from "./DlgHeader.vue?vue&type=template&id=735f7ab6&scoped=true&lang=html&"
import script from "./DlgHeader.vue?vue&type=script&lang=js&"
export * from "./DlgHeader.vue?vue&type=script&lang=js&"
import style0 from "./DlgHeader.vue?vue&type=style&index=0&id=735f7ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735f7ab6",
  null
  
)

export default component.exports